import { axiosBearerSite } from "../api";

const contactService = {
  sendMessageStartSite: async (data) => {

    const result = axiosBearerSite.post("site/com.levty/levtyFacade/sendMessageStartSite", data)
      .then(response => {
        if (response.status === 200) {
          if (response.data.return === "blacklist") {
            return "blacklist";
          } else {
            return "ok";
          }
        }
        return "error";
      })
      .catch(err => {
        console.log(err);
      });
    return result;
  },
  getBusinessAccount: async (data) => {
    
    const result = axiosBearerSite.get("site/com.levty/levtyFacade/getBussinessAcount", data)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
        return "error";
      })
      .catch(err => {
        console.log(err);
      });
    return result;
  },
  
  validatesRegistration: async (data) => {
    const result = axiosBearerSite.post("site/com.levty/levtyFacade/validatesRegistration", data)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
        return null;
      })
      .catch(err => {
        console.log(err);
        return null;
      });
      return result;
  }
}

export default contactService;
